import React, {useState} from 'react';

export default (props) => {

	const [vals, setVals] = useState({referee1: '', referee2: ''});

	console.log(props);

	const {name, label, custom, onChange, dataPath} = props;

	const labelTitle = props.schemaOptions?.["labelTitle"]?.value || '';
	const title = props.schemaOptions?.["title"]?.value || '';
	const size = props.schemaOptions?.["size"]?.value || 1;


	const containerStyle = {
		display: 'flex',
		justifyContent: 'space-between'
	};

	const singleRefStyle = {
		display: 'flex',
		justifyContent: 'space-between',
		width : '50%',
		margin: '10px',
	}
	const inputStyle= {
		width: '70%',
		height: '30px',
		border: 'none',
		padding: '5px'
	}
	const btnStyle = {
		width:'20%',
		height: '30px',
		border: 'none',
		color: 'white',
		background: 'red',
	}

	const sendData = (ev) =>{

    	const matchId = 4;
        const url = `${window.location.origin}/admin/api/dhbmatch/${matchId}/report`;

        console.log(ev);

        //sending only the value of referee field
        const dataBody = {};
        let payload = {};

    	const requestOptions = {
		    method: 'PUT',
		    headers: { 'Content-Type': 'application/json' },
		    body: JSON.stringify( payload )
		};
		///admin/api/dhbmatches/{id}
		fetch(url, requestOptions)
		    .then(response => response.json())
		    .then(data => {
		    	console.log(data);
		    } );
    }

    const update = (ev) => {

    	const {name, value} = ev.target;

    	const newVals = {...vals};
    	newVals[name] = value;

    	setVals(newVals);
    }


	return (
			
		<div style={containerStyle}>
		
			<div style={singleRefStyle}>
				<input 
					type="text" 
					name="referee1"
					placeholder='Name, Vorname' 
					onChange={update}
					style={inputStyle}
					value={vals.referee1}
				/> 
				<button 
					name="btn1"
					onClick={sendData}
					style={ btnStyle }
				>Confirmed</button>
			</div>
			
			<div style={singleRefStyle}>
				<input 
					type="text" 
					name="referee2"
					placeholder='Name, Vorname' 
					onChange={update}
					style={inputStyle}
					value={vals.referee2}
				/> 
				<button 
					name="btn2"
					onClick={sendData}
					style={btnStyle}
				>Confirmed</button>
			</div>
		</div>
	);
}